import { FC, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ListGroup } from 'react-bootstrap';
import { useNavigationData } from '../../modules/NavigationProvider';
import { useDataContext } from '../../modules/data/DataContext';
import ListItem from './components/ListItem';

const AlertsPage: FC = () => {
  const { t } = useTranslation('alerts');
  const { setPath, setButtonText, setHeaderText } = useNavigationData();
  const { alerts } = useDataContext();

  useLayoutEffect(() => {
    setPath('/menu');
    setButtonText();
    setHeaderText(t('title'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center overflow-hidden h-100 mt-5">
      <div
        id="alert-list"
        className="overflow-auto"
        style={{ opacity: alerts?.length ? 1 : 0 }}
      >
        <ListGroup>
          {alerts.map((alert, index) => (
            <ListGroup.Item
              key={index}
              className="d-flex justify-content-start"
            >
              <ListItem alert={alert} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    </div>
  );
};

export default AlertsPage;
